<script lang="ts">
	import SectionInformationBlock from '$lib/components/Contentblocks/SectionInformationBlock.svelte';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';

	export let cards: Array<{ name: string; description: string }>;
	export let id: string = '';
	export let additionalClass = '';

	const { t } = getTranslate();
</script>

{#if cards && cards.length > 0}
	<SectionInformationBlock
		additionalClass={classes(additionalClass, '')}
		{id}
		sectionTitle={$t('section-title.why.course-detail')}
		title={$t('title.why.course-detail')}
		description={$t('description.why.course-detail')}
	>
		<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-14 mr-auto">
			{#each cards as { name, description }}
				<div class="flex flex-col gap-2 min-h-[13rem] min-w-[13.3125rem] max-w-[13.3125rem]">
					<div class="text-xl font-bold">{name}</div>
					<div class="text-lg">{description}</div>
				</div>
			{/each}
		</div>
	</SectionInformationBlock>
{/if}
